import React from 'react'
import { useTheme } from '@mui/material'
import StatusTag from 'redesign/components/atoms/status-tag'
import { MainContainer, Container, EndText } from './styles'
import type { StatesFooterProps } from './types'
import { normalizeStatus } from './utils'

const StatesFooter: React.FC<StatesFooterProps> = ({
  startText,
  secondaryText,
  endText,
  endTextVariant = 'body2',
  secondaryColorVariant,
  endTextDataTestId,
  status,
  hasPadding = true,
}) => {
  const theme = useTheme()

  return (
    <MainContainer hasPadding={hasPadding}>
      <Container>
        {startText && <StatusTag label={startText} variant={normalizeStatus(status)} />}
        {secondaryText && <StatusTag label={secondaryText} />}
      </Container>
      {endText && (
        <EndText
          data-testid={endTextDataTestId}
          color={secondaryColorVariant ?? theme.palette.text.secondary}
          variant={endTextVariant}
        >
          {endText}
        </EndText>
      )}
    </MainContainer>
  )
}

export default StatesFooter
